import React from 'react';
import AdminLayout from '../../../components/Layout/AdminLayout'
import EditCancelReason from './EditCancelReason'
import { restrictUrls } from '../../../helpers/adminPrivileges';
import messages from '../../../locale/messages';

function action({ store, params, intl }) {
    const title = intl.formatMessage(messages.editCancelReason);

    let isAdminAuthenticated = store.getState().runtime.isAdminAuthenticated;
    let adminPrivileges = store.getState().account.privileges && store.getState().account.privileges.privileges;
    let privileges = store.getState().commonSettings && store.getState().commonSettings.privileges;

    if (!isAdminAuthenticated) {
        return { redirect: '/siteadmin/login' }
    }
    // Admin restriction
    if (!restrictUrls('/siteadmin/cancel-reasons/edit/', adminPrivileges, privileges)) {
        return { redirect: '/siteadmin' };
    }
    const id = Number(params.id);

    return {
        title,
        component: (
            <AdminLayout>
                <EditCancelReason title={title} id={id} />
            </AdminLayout>
        )
    }
}

export default action;